import { keyEnumObject, KeyTypeOf } from '@berlin-front/common/utils';

/**
 * タイポグラフィ種別
 */
export const TEXT_SIZE_MAP = {
  heading: 'heading',
  heading6: 'heading6',
  subtitle1: 'subtitle1',
  body2: 'body2',
  caption: 'caption',
} as const;

/**
 * タイポグラフィサイズタイプ。
 */
export type TextSize = KeyTypeOf<typeof TEXT_SIZE_MAP>;

/**
 * タイポグラフィサイズ種別定数。
 */
export const TEXT_SIZE = keyEnumObject(TEXT_SIZE_MAP);

/**
 * タイポグラフィ色
 */
export const TEXT_COLOR_MAP = {
  default: 'normal',
  error: 'error',
  burnt: 'burnt',
  primary: 'primary',
} as const;

/**
 * タイポグラフィ色タイプ。
 */
export type TextColor = KeyTypeOf<typeof TEXT_COLOR_MAP>;

/**
 * タイポグラフィ色種別定数。
 */
export const TEXT_COLOR = keyEnumObject(TEXT_COLOR_MAP);

/**
 * タイポグラフィを使用する。(使用中止)
 */
// export const useText = (textSize: Ref<TextSize> | TextSize): ComputedRef<string> =>
//   computed(() => TEXT_SIZE_MAP[unref(textSize)]);

/**
 * テキスト太さ。
 */
export const TEXT_WEIGHT_MAP = {
  weight400: '400',
  weight700: '700',
} as const;

/**
 * テキスト太さタイプ。
 */
export type TextWeight = KeyTypeOf<typeof TEXT_WEIGHT_MAP>;

/**
 * テキスト太さ種別定数。
 */
export const TEXT_WEIGHT = keyEnumObject(TEXT_WEIGHT_MAP);

/**
 * テキスト太さを使用する。(使用中止)
 */
// export const useTextWeight = (textWeight: Ref<TextWeight>): ComputedRef<string> =>
//   computed(() => TEXT_WEIGHT_MAP[textWeight.value]);

/**
 * 行の高さ。
 */
export const LINE_HEIGHT_MAP = {
  height100: '100',
  height125: '125',
  height150: '150',
} as const;

export const SIZE_HEIGHT_MAP = {
  heading: '100',
  heading6: '125',
  subtitle1: '150',
  body2: '125',
  caption: '125',
};

/**
 * 行の高さタイプ。
 */
export type LineHeight = KeyTypeOf<typeof LINE_HEIGHT_MAP>;

/**
 * 行の高さ種別定数。
 */
export const LINE_HEIGHT = keyEnumObject(LINE_HEIGHT_MAP);

/**
 * 字間。
 */
export const LETTER_SPACING_MAP = {
  spacing1: '1',
} as const;

/**
 * 字間タイプ。
 */
export type LetterSpacing = KeyTypeOf<typeof LETTER_SPACING_MAP>;

/**
 * 字間種別。
 */
export const LETTER_SPACING = keyEnumObject(LETTER_SPACING_MAP);
